(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-back-pelvis"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pinkPhrases = [
      'השינוי הזה עשוי להשפיע על תנוחת הגב התחתון ולהוסיף אי־נוחות לאזור שכבר רגיש.',
      'השינוי הזה משפיע גם על התנוחה של הגב התחתון, ולפעמים הוא מוסיף אי־נוחות לאזור שכבר רגיש.'
    ];

    const emphasize = (scope = document) => {
      scope.querySelectorAll('.vbp__paragraph:first-child strong').forEach((strong) => {
        if (strong.dataset.vbpPinkReady === 'true') return;
        const phrase = pinkPhrases.find((item) => strong.textContent.includes(item));
        if (!phrase) return;
        const walker = document.createTreeWalker(strong, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const index = node.nodeValue.indexOf(phrase);
          if (index < 0) continue;
          const before = node.nodeValue.slice(0, index);
          const after = node.nodeValue.slice(index + phrase.length);
          const pink = document.createElement('span');
          pink.className = 'vbp__pink-emphasis';
          pink.textContent = phrase;
          node.replaceWith(before, pink, after);
          strong.dataset.vbpPinkReady = 'true';
          break;
        }
      });
    };

    const setup = (scope = document) => {
      scope.querySelectorAll('.vbp__video').forEach((video) => {
        if (video.dataset.viewportReady) return;
        video.dataset.viewportReady = 'true';
        video.autoplay = false;
        video.defaultMuted = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        let visible = false;
        const reset = () => {
          video.pause();
          if (video.readyState > 0) video.currentTime = 0;
        };
        const play = () => {
          if (!visible || document.hidden || !video.isConnected) return;
          video.preload = 'auto';
          video.play().catch(() => {});
        };
        const update = (next) => {
          if (next === visible) return;
          visible = next;
          if (visible) {
            reset();
            play();
          } else reset();
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio === 0) update(false);
            else if (entry.intersectionRatio >= 0.15) update(!document.hidden);
          });
        }, { rootMargin: '0px', threshold: [0, 0.15] });
        reset();
        video.addEventListener('loadedmetadata', () => { if (!visible) reset(); });
        video.addEventListener('canplay', play);
        video.addEventListener('play', () => { if (!visible || document.hidden) reset(); });
        const visibility = () => {
          if (document.hidden) update(false);
          else {
            const rect = video.getBoundingClientRect();
            const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
            const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
            update(rect.width * rect.height > 0 && width * height / (rect.width * rect.height) >= 0.15);
          }
        };
        document.addEventListener('visibilitychange', visibility);
        document.addEventListener('shopify:section:unload', function unload(event) {
          if (!event.target.contains(video)) return;
          update(false);
          observer.disconnect();
          document.removeEventListener('visibilitychange', visibility);
          document.removeEventListener('shopify:section:unload', unload);
        });
        observer.observe(video);
      });
      emphasize(scope);
    };
    setup();
    window.addEventListener('resize', () => emphasize());
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-heart-comparison"] && !Shopify.designMode) return;
  try {
    

(() => {
  const init = (root) => {
    const sections = root.matches?.('.hpc') ? [root] : root.querySelectorAll('.hpc');
    sections.forEach((section) => {
      if (section.dataset.hpcReady) return;
      section.dataset.hpcReady = 'true';
      section.querySelectorAll('[data-hpc-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          section.dataset.comparison = button.dataset.hpcChoice;
          section.querySelectorAll('[data-hpc-choice]').forEach((choice) => {
            choice.setAttribute('aria-pressed', String(choice === button));
          });
        });
      });
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          section.classList.add('hpc--reveal');
          observer.disconnect();
        }
      }, { threshold:0.08 });
      observer.observe(section);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once:true });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-night-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    const sections = root.matches?.('.vna') ? [root] : root.querySelectorAll('.vna');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    sections.forEach((section) => {
      if (section.dataset.vnaObserved) return;
      section.dataset.vnaObserved = 'true';
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          section.classList.add('vna--reveal');
          observer.disconnect();
        }
      }, { threshold: 0.08 });
      observer.observe(section);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-product-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    const sections = root.matches?.('.vpc') ? [root] : root.querySelectorAll('.vpc');
    sections.forEach((section) => {
      if (section.dataset.vpcReady) return;
      section.dataset.vpcReady = 'true';
      section.querySelectorAll('[data-vpc-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          section.dataset.comparison = button.dataset.vpcChoice;
          section.querySelectorAll('[data-vpc-choice]').forEach((choice) => {
            choice.setAttribute('aria-pressed', String(choice === button));
          });
        });
      });
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          section.classList.add('vpc--reveal');
          observer.disconnect();
        }
      }, { threshold:0.08 });
      observer.observe(section);
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once:true });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-right-support"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (scope = document) => {
      scope.querySelectorAll('.vrs__video').forEach((video) => {
        if (video.dataset.viewportReady) return;
        video.dataset.viewportReady = 'true';
        video.autoplay = false;
        video.defaultMuted = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        let visible = false;
        const reset = () => {
          video.pause();
          if (video.readyState > 0) video.currentTime = 0;
        };
        const play = () => {
          if (!visible || document.hidden || !video.isConnected) return;
          video.preload = 'auto';
          video.play().catch(() => {});
        };
        const update = (next) => {
          if (next === visible) return;
          visible = next;
          if (visible) {
            reset();
            play();
          } else reset();
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio === 0) update(false);
            else if (entry.intersectionRatio >= 0.15) update(!document.hidden);
          });
        }, { rootMargin: '0px', threshold: [0, 0.15] });
        reset();
        video.addEventListener('loadedmetadata', () => { if (!visible) reset(); });
        video.addEventListener('canplay', play);
        video.addEventListener('play', () => { if (!visible || document.hidden) reset(); });
        const visibility = () => {
          if (document.hidden) update(false);
          else {
            const rect = video.getBoundingClientRect();
            const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
            const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
            update(rect.width * rect.height > 0 && width * height / (rect.width * rect.height) >= 0.15);
          }
        };
        document.addEventListener('visibilitychange', visibility);
        document.addEventListener('shopify:section:unload', function unload(event) {
          if (!event.target.contains(video)) return;
          update(false);
          observer.disconnect();
          document.removeEventListener('visibilitychange', visibility);
          document.removeEventListener('shopify:section:unload', unload);
        });
        observer.observe(video);
      });
    };
    setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-sleep-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (scope = document) => {
      scope.querySelectorAll('.vss__video').forEach((video) => {
        if (video.dataset.viewportReady) return;
        video.dataset.viewportReady = 'true';
        video.autoplay = false;
        video.defaultMuted = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        let visible = false;
        const reset = () => {
          video.pause();
          if (video.readyState > 0) video.currentTime = 0;
        };
        const play = () => {
          if (!visible || document.hidden || !video.isConnected) return;
          video.preload = 'auto';
          video.play().catch(() => {});
        };
        const update = (next) => {
          if (next === visible) return;
          visible = next;
          if (visible) {
            reset();
            play();
          } else reset();
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio === 0) update(false);
            else if (entry.intersectionRatio >= 0.15) update(!document.hidden);
          });
        }, { rootMargin: '0px', threshold: [0, 0.15] });
        reset();
        video.addEventListener('loadedmetadata', () => { if (!visible) reset(); });
        video.addEventListener('canplay', play);
        video.addEventListener('play', () => { if (!visible || document.hidden) reset(); });
        const visibility = () => {
          if (document.hidden) update(false);
          else {
            const rect = video.getBoundingClientRect();
            const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
            const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
            update(rect.width * rect.height > 0 && width * height / (rect.width * rect.height) >= 0.15);
          }
        };
        document.addEventListener('visibilitychange', visibility);
        document.addEventListener('shopify:section:unload', function unload(event) {
          if (!event.target.contains(video)) return;
          update(false);
          observer.disconnect();
          document.removeEventListener('visibilitychange', visibility);
          document.removeEventListener('shopify:section:unload', unload);
        });
        observer.observe(video);
      });
    };
    setup();
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vonela-video-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-vvr-carousel]').forEach(carousel => {
      if (carousel.dataset.carouselReady) return;
      carousel.dataset.carouselReady = 'true';
      const track = carousel.querySelector('[data-vvr-track]');
      const move = direction => {
        const card = track.querySelector('.vvr-card');
        const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };
      carousel.querySelector('[data-vvr-next]').addEventListener('click', () => move(1));
      carousel.querySelector('[data-vvr-prev]').addEventListener('click', () => move(-1));
    });
    root.querySelectorAll('[data-video-reviews] video').forEach(video => {
      if (video.dataset.reviewReady) return;
      video.dataset.reviewReady = 'true';
      const loadPoster = () => {
        if (video.dataset.poster) {
          video.poster = video.dataset.poster;
          video.removeAttribute('data-poster');
        }
        video.querySelectorAll('img[data-src]').forEach(image => {
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
        });
      };
      const posterObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          loadPoster();
          posterObserver.disconnect();
        }
      }, { rootMargin: '400px 0px', threshold: 0 }) : null;
      if (posterObserver) posterObserver.observe(video);
      else loadPoster();

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = false;
      video.playsInline = true;
      video.controls = false;
      let visible = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const pause = () => video.pause();
      const play = () => {
        if (!visible || !video.isConnected || document.hidden || reducedMotion.matches || document.documentElement.classList.contains('vax-pause')) {
          pause();
          return;
        }
        loadPoster();
        if (!video.dataset.sourcesReady) {
          video.querySelectorAll('source[data-src]').forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.dataset.sourcesReady = 'true';
          video.load();
        }
        video.muted = true;
        video.play().catch(() => {});
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          visible = entry.isIntersecting && entry.intersectionRatio >= .15;
          play();
        });
      }, { threshold: [0, .15] }) : null;
      if (observer) observer.observe(video);
      else {
        video.controls = true;
        video.addEventListener('pointerdown', () => { visible = true; play(); }, { once: true });
      }
      const motionObserver = new MutationObserver(play);
      motionObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      video.addEventListener('play', play);
      video.addEventListener('canplay', play);
      document.addEventListener('visibilitychange', play);
      window.addEventListener('pageshow', play);
      reducedMotion.addEventListener('change', play);
      const section = video.closest('.shopify-section');
      const unload = (event) => {
        if (event.target !== section) return;
        pause();
        observer?.disconnect();
        posterObserver?.disconnect();
        motionObserver.disconnect();
        video.removeEventListener('play', play);
        video.removeEventListener('canplay', play);
        document.removeEventListener('visibilitychange', play);
        window.removeEventListener('pageshow', play);
        reducedMotion.removeEventListener('change', play);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      play();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
